import {
  FulfillmentTypeCollection,
  FulfillmentType,
  ServiceLocation,
  CartPickupLocationResponse,
} from '@commerce-fulfillment-webcomponents/sdk';
import { SessionService } from '@nextgen-web-framework/core';
import {
  checkoutFulfillmentOptions,
  DataTypesEnums,
  ICheckoutAnyType,
  ICheckoutCmsResponse,
  ICheckoutPickupStoresMap,
  ICmsfulfillmentTypes,
  IFulfillmentCmsResponse,
  IFulfillmentTypesAndStoreMap,
  IkeyStringWithKeyStringObject,
  IpropServiceLocationAddress,
} from '../types';
import { ContactType, Checkout, CheckoutProfileFulfillment, CheckoutServiceLevel } from '../services/models';
import { CheckoutProfileService } from '../services';
export const eventsPayloadTransformer = (version: string, payload: object): object =>
  version == '1.0.0'
    ? {
        ...payload,
        version: '1.0.0',
      }
    : payload;

export const transformCheckoutToCheckoutProfile = (
  data: Checkout,
  defaultWarehouseId?: string,
): CheckoutProfileFulfillment => {
  const checkoutProfileData = CheckoutProfileService.getCheckoutProfile();
  const serviceLevel: CheckoutServiceLevel = {};
  const checkoutProfileFulfillment: CheckoutProfileFulfillment = {
    id: data?.fulfillment?.id,
  };
  data?.fulfillment?.serviceLevel?.id
    ? (serviceLevel['deliveryOptionId'] = data?.fulfillment?.serviceLevel?.id)
    : (serviceLevel['deliveryOptionId'] = checkoutProfileData.fulfillmentType.serviceLevel?.deliveryOptionId);
  data?.fulfillment?.address?.postalCode && data?.fulfillment?.address?.contactType == ContactType.Shipping
    ? (serviceLevel['deliveryAddress'] = data?.fulfillment?.address)
    : (serviceLevel['deliveryAddress'] = checkoutProfileData.fulfillmentType.serviceLevel?.deliveryAddress);
  checkoutProfileFulfillment.serviceLevel = serviceLevel;
  if (data?.fulfillment?.serviceLocation?.id) {
    checkoutProfileFulfillment.serviceLocation = data?.fulfillment?.serviceLocation;
  }
  checkoutProfileFulfillment.warehouse = data?.fulfillment?.warehouseId || defaultWarehouseId;
  return checkoutProfileFulfillment;
};

export const transformFulfillmentCmsData = (cmsData: IFulfillmentCmsResponse) => {
  const transformedCmsData: IkeyStringWithKeyStringObject = {};
  cmsData?.types?.map((type: ICmsfulfillmentTypes) => {
    transformedCmsData[type.fulfillment_type_id as string] = {
      iconUrl: type?.image?.url,
    };
  });
  return transformedCmsData;
};

export const transformCheckoutCmsData = (cmsData: ICheckoutCmsResponse) => {
  const transformedCmsData = { tnc: cmsData?.terms_conditions };
  return transformedCmsData;
};

export const transformFulfillmentTypesData = (
  fulfillmentTypes: FulfillmentTypeCollection,
): IFulfillmentTypesAndStoreMap => {
  const fulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap = {
    delivery: { isExist: false, isRestricted: false },
    pickUp: {},
    storeMap: {},
    pincode: '',
    needToDisabledLocationHeader: false,
  };
  const cloneFulfillmentTypes = structuredClone(fulfillmentTypes);
  let isPickUpExist = false;
  cloneFulfillmentTypes.fulfillmentTypes
    ?.sort((fulfillmentTypeA, fulfillmentTypeB) =>
      fulfillmentTypeA?.rank && fulfillmentTypeB?.rank ? fulfillmentTypeA.rank - fulfillmentTypeB.rank : 0,
    )
    .forEach((fulfillmentType) => {
      if (fulfillmentType.id != checkoutFulfillmentOptions.HOMEDELIVERY) {
        fulfillmentTypesAndStoreMap.pickUp[fulfillmentType.id] = { isExist: true, isRestricted: false };
        fulfillmentTypesAndStoreMap.storeMap[fulfillmentType.id] = {
          isSelected: false,
          storeName: fulfillmentType?.description?.[0]?.text || '',
          storeList: [],
        };
        isPickUpExist = true;
      } else {
        fulfillmentTypesAndStoreMap.delivery.isExist = true;
        fulfillmentTypesAndStoreMap.delivery.isRestricted = false;
      }
    });
  SessionService.getSession().isAnonymous() &&
    !isPickUpExist &&
    (fulfillmentTypesAndStoreMap.needToDisabledLocationHeader = true);
  return fulfillmentTypesAndStoreMap;
};

export const getValueCheck = (value?: any, type?: string) => {
  if (!value) {
    return type == DataTypesEnums.TYPE_STRING ? '' : 0;
  }
  return value;
};

export const getAddressLineExtended = (text: string | undefined, extension: string) => {
  if (!text) {
    return '';
  }
  switch (extension) {
    case 'quote':
      return `‘${text}’`;
    case 'space':
      return `${text} `;
    case 'bracket':
      return `(${text})`;
    default:
      return `${text}, `;
  }
};

export const tranformServiceLocationToStoreCardData = (
  serviceLocation: ServiceLocation & IpropServiceLocationAddress,
) => ({
  id: getValueCheck(serviceLocation.id, DataTypesEnums.TYPE_STRING),
  name: getValueCheck(serviceLocation?.name, DataTypesEnums.TYPE_STRING),
  addressLine:
    (serviceLocation?.address &&
      `${getAddressLineExtended(serviceLocation.address?.line1, 'coma')} ${getAddressLineExtended(
        serviceLocation.address?.line2,
        'coma',
      )} ${getAddressLineExtended(serviceLocation.address?.city, 'coma')} ${getValueCheck(
        serviceLocation.address?.postCode,
        DataTypesEnums.TYPE_STRING,
      )}`) ||
    '',
  contact: getValueCheck(serviceLocation?.phone, DataTypesEnums.TYPE_STRING),
  allItemsAvailable: typeof serviceLocation?.allItemsAvailable != null ? serviceLocation?.allItemsAvailable : true,
  schedule: serviceLocation?.schedule || {},
  serviceLocation: serviceLocation,
  lat: getValueCheck(Number(serviceLocation?.address?.lat), DataTypesEnums.TYPE_NUMBER),
  lng: getValueCheck(Number(serviceLocation?.address?.long), DataTypesEnums.TYPE_NUMBER),
  region: getValueCheck(serviceLocation.address?.region, DataTypesEnums.TYPE_STRING),
});

export const transformFulfillmentLocations = (
  cartPickupLocationResponse: CartPickupLocationResponse,
  oldState: IFulfillmentTypesAndStoreMap,
  pincode: string,
  pagination?: boolean,
): IFulfillmentTypesAndStoreMap => {
  const finalState: IFulfillmentTypesAndStoreMap = structuredClone(oldState);
  const fulfillmentData: Array<FulfillmentType> = cartPickupLocationResponse.fulfillmentTypes || [];
  const fulfillmentType = fulfillmentData?.[0]?.id || '';
  finalState.pincode = pincode;
  finalState.pickUp[fulfillmentType] = { isRestricted: fulfillmentData?.[0]?.isRestricted || false, isExist: true };
  if (finalState.storeMap[fulfillmentType]) {
    const newStoreList =
      fulfillmentData?.[0]?.serviceLocations?.map((serviceLocation: ServiceLocation & IpropServiceLocationAddress) =>
        tranformServiceLocationToStoreCardData(serviceLocation),
      ) || [];
    const storeList = pagination ? [...finalState.storeMap[fulfillmentType].storeList, ...newStoreList] : newStoreList;
    finalState.storeMap[fulfillmentType].storeList = storeList;
    finalState.storeMap[fulfillmentType].lastEvaluatedKey =
      cartPickupLocationResponse?.metadata?.lastEvaluationKey || '';
  }

  return finalState;
};

export const getSelectedFulfillmentLocationStoreMap = (
  oldState: ICheckoutPickupStoresMap,
  selectedFulfillmentId: string,
): ICheckoutPickupStoresMap => {
  const finalState: ICheckoutPickupStoresMap = structuredClone(oldState);
  Object.keys(finalState).forEach((storeOptionName) => {
    storeOptionName == selectedFulfillmentId
      ? (finalState[storeOptionName].isSelected = true)
      : (finalState[storeOptionName].isSelected = false);
  });
  return finalState;
};

export const resetThirdPartyStoreList = (FulfillmentTypesAndStoreMap: IFulfillmentTypesAndStoreMap) => {
  Object.keys(FulfillmentTypesAndStoreMap.storeMap).forEach((storeOptionName) => {
    if (storeOptionName != checkoutFulfillmentOptions.BOPIS) {
      FulfillmentTypesAndStoreMap.storeMap[storeOptionName].storeList = [];
    }
  });
  return FulfillmentTypesAndStoreMap;
};

export const isEasyDeliveryOrBopisOption = (storeOptionName: string) =>
  storeOptionName == checkoutFulfillmentOptions.BOPIS ||
  storeOptionName == checkoutFulfillmentOptions.EASYDELIVERYPOINT;

export const getCountrySpecificMasterConfig = () => {
  const masterData = MasterDataService.getMasterData<ICheckoutAnyType>('CheckoutConfig');
  const currentLocale = ConfigService.getConfigs().NEXT_PUBLIC_COUNTRY as string;
  return masterData?.find((data: ICheckoutAnyType) => data?.pk?.toLowerCase() === currentLocale?.toLowerCase());
};
